import "./index.scss";

import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box } from "@mui/material";
import { ReactComponent as EditIcon } from "assets/images/square-buttons/edit-line.svg";

const TitleWithOptions = ({
  title,
  buttonClass,
  view = false,
  edit,
}: {
  title: string;
  buttonClass?: string;
  view?: boolean;
  edit?: any;
}) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <p className="title">{title}</p>
      <Box display={"flex"} flexDirection={"row"}>
        {view && (
          <button className={`button-option ${buttonClass}`}>
            <VisibilityIcon htmlColor="#33A9A0" />
          </button>
        )}
        <Box width={10} />
        {edit && (
          <button className={`button-option ${buttonClass}`} onClick={edit}>
            <EditIcon />
          </button>
        )}
      </Box>
    </Box>
  );
};

export default TitleWithOptions;
